import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  signal,
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { BreakGames, ErrorMessages } from 'src/app/models/game.model';
import { GameService } from 'src/app/state/gameState/game.service';
import { GameQuery } from 'src/app/state/gameState/game.query';
import { GameInstanceService } from 'src/app/services/game-instance.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-coffee-break-bar',
  templateUrl: './coffee-break-bar.component.html',
  styleUrls: ['./coffee-break-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CoffeeBreakBarComponent implements OnInit {
  @Input() coffeeBreak = false;
  @Input() countdown: number;
  @Input() spotTheCountryTitle: string;
  @Input() spotTheCountrySubtitle: string;

  goToCoffeeBreakButton$: Observable<boolean>;
  numberOfCoffees$: Observable<number>;

  openedMenu = false;
  breakGames = BreakGames;
  gamePlaying$: Observable<BreakGames>;
  isPlaying = signal(false);
  breakGamePlaying: Subscription;

  countryOnePath = signal('');
  countryTwoPath = signal('');
  countryThreePath = signal('');
  countriesFoundSubscription: Subscription;
  firstCountryCodeFlag = signal('');
  secondCountryCodeFlag = signal('');
  thirdCountryCodeFlag = signal('');
  type = signal<string | null>(null);

  constructor(
    private router: Router,
    private gameService: GameService,
    private gameQuery: GameQuery,
    public gameInstanceService: GameInstanceService
  ) {
    this.numberOfCoffees$ = this.gameQuery.coffeesAvailable$;
    this.gameService.updateBreakError('');
    this.gamePlaying$ = this.gameQuery
      .select('breakGamePlaying')
      .pipe(untilDestroyed(this));
    this.gameQuery
      .select('spotTheCountryGameResult')
      .pipe(untilDestroyed(this))
      .subscribe((res) => {
        if (res === 'success') {
          this.type.set(res);
        } else if (res === 'fail') {
          this.type.set(res);
        } else {
          this.type.set(null);
        }
      });

    this.countriesFoundSubscription = this.gameQuery
      .select('spotTheCountriesFound')
      ?.pipe(untilDestroyed(this))
      .subscribe((res) => {
        console.log({ res });

        const first = res[1] === undefined ? '' : res[1];
        const second = res[2] === undefined ? '' : res[2];
        const third = res[3] === undefined ? '' : res[3];
        this.firstCountryCodeFlag.set(first);
        this.secondCountryCodeFlag.set(second);
        this.thirdCountryCodeFlag.set(third);

        this.countryOnePath.set(`../../../assets/flags/${first}.svg`);
        this.countryTwoPath.set(`../../../assets/flags/${second}.svg`);
        this.countryThreePath.set(`../../../assets/flags/${third}.svg`);
      });

    this.breakGamePlaying = this.gameQuery
      .select('breakGamePlaying')
      .pipe(untilDestroyed(this))
      .subscribe((res) => {
        this.isPlaying.set(res !== null);
      });
  }

  ngOnInit() {}

  ionViewWillExit() {
    this.gameService.updateBreakGamePlaying(null);
  }

  goToCoffeeBreak($event: any) {
    this.router.navigate(['coffee-break']);
  }

  toggleTasksMenu() {
    if (!this.isPlaying()) {
      this.openedMenu = !this.openedMenu;
    } else {
      this.gameService.updateErrorMessage(ErrorMessages.breakTaskPlaying);
    }
  }

  preventClick(e: any) {
    e.stopPropagation();
  }

  goToTask(task: BreakGames) {
    if (!this.isPlaying()) {
      this.toggleTasksMenu();
      if (task === BreakGames.spotTheCountry) {
        if (
          this.gameInstanceService.timesPlayedPerBreakSpotTheCountry.getValue() >
          0
        ) {
          return;
        }
        this.gameService.updateSpotTheCountryOverlay(1);
      }
      if (task === BreakGames.drinkACoffee) {
        if (
          this.gameInstanceService.timesPlayedPerBreakDrinkCoffee.getValue() > 0
        ) {
          return;
        }
        this.gameService.updateBreakGamePlaying(task);
      }
      if (task === BreakGames.emoji) {
        if (this.gameInstanceService.timesPlayedPerBreakEmoji.getValue() > 0) {
          return;
        }
        this.gameService.updateBreakGamePlaying(task);
      }
      if (task === BreakGames.talkToAnExpert) {
        if (
          this.gameInstanceService.timesPlayedPerBreakTalkToAnExpert.getValue() >
          0
        ) {
          return;
        }
        this.gameService.updateBreakGamePlaying(task);
        this.gameInstanceService.startQuiz();
      }
    } else {
      this.gameService.updateErrorMessage(ErrorMessages.breakTaskPlaying);
    }
  }
}
